import { generatePath } from 'react-router-dom';

import { NotificationReader } from 'types';
import { addParamsToUrl } from 'utils/query';
import type {
  PushConfig,
  PushDevice,
  SavePushDeviceRequest,
} from 'store/api/notifications/types';

import { URL } from '../constants';
import { apiInstance } from '../instance';

import { NotificationRequest, NotificationResponse } from './types';

export const getNotifications = (params: NotificationRequest) =>
  apiInstance.get<NotificationResponse>(
    addParamsToUrl(URL.GET_NOTIFICATIONS, params)
  );

export const markAsRead = (id: number) =>
  apiInstance.post<NotificationReader>(
    generatePath(URL.MARK_AS_READ_NOTIFICATION, { id: String(id) })
  );

export const markAllAsRead = () =>
  apiInstance.post<number[]>(URL.MARK_ALL_AS_READ_NOTIFICATIONS);

// WEB PUSH (owner, 24 Oct 2026): used outside React (utils/push). A 404 (a
// Main without the push routes yet) must not open the Not Found page.
export const getPushDevices = (signal?: AbortSignal) =>
  apiInstance.get<PushDevice[]>(URL.PUSH_DEVICES, {
    signal,
    headers: { 'allow-not-found': 'true' },
  });

export const savePushDevice = (data: SavePushDeviceRequest) =>
  apiInstance.post<PushDevice>(URL.PUSH_DEVICES, data);

export const getPushConfig = () =>
  apiInstance.get<PushConfig>(URL.PUSH_CONFIG, {
    headers: { 'allow-not-found': 'true' },
  });

export const deletePushDevice = (id: number, signal?: AbortSignal) =>
  apiInstance.delete(generatePath(URL.PUSH_DEVICE, { id: String(id) }), {
    signal,
  });
